<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Selecione o Responsável' | translate}}</ion-title>
  </ion-buttons>
</ion-header>


<ion-content padding>
  <div class="gradient-extendido"></div>

  <ion-card class="gradient-extendido-recuo">
    <ion-card-content>
      <div class="list-mini">
        <ion-list *ngFor="let i of responsaveis;">
          <button class="list-item" ion-item (click)="selecionar(i);">
            <ion-row no-padding class="content-row one-line">

              <ion-col no-padding width-18 class="item-avatar">
                <!-- <preload-image class="avatar-image" [ratio]="{w:1, h:1}" [src]="i.foto | image"></preload-image> -->
              </ion-col>

              <ion-col no-padding width-72 class="item-content">
                <h3 class="item-title">{{i.nome}}</h3>
                <p>{{i.parentesco}}</p>
              </ion-col>

              <ion-col no-padding width-10 class="item-icon">
                <ion-icon name="ios-arrow-forward-outline"></ion-icon>
              </ion-col>

            </ion-row>
          </button>
        </ion-list>

        <ion-list [hidden]="responsaveis.length">
          <button class="list-item" ion-item>
            <ion-row no-padding class="content-row one-line">
              <ion-col no-padding width-100 class="item-content">
                <h3 text-center class="item-title item-title-peq">{{'Nenhuma Dependente Localizado' | translate}}.</h3>
              </ion-col>
            </ion-row>
          </button>
        </ion-list>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content>